module.exports = __webpack_public_path__ + "img/DE00617.b2e74d93.png";